export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";
export const SETUP_ACCOUNT_REQUEST = "SETUP_ACCOUNT_REQUEST";
export const SETUP_ACCOUNT_FAILURE = "SETUP_ACCOUNT_FAILURE";
export const SETUP_ACCOUNT_SUCCESS = "SETUP_ACCOUNT_SUCCESS";
export const SET_SESSION_STATUS = "SET_SESSION_STATUS";
export const SET_SELECTED_ROLE_ID = "SET_SELECTED_ROLE_ID";
export const UPDATE_LOCAL_USER_SETTINGS = "UPDATE_LOCAL_USER_SETTINGS";
export const UPDATE_LOCAL_USER_THEME = "UPDATE_LOCAL_USER_THEME";
export const UPDATE_LOCAL_USER_PUSH_NOTIFICATIONS = "UPDATE_LOCAL_USER_PUSH_NOTIFICATIONS";
export const GET_USER_MENUS_SUCCESS = "GET_USER_MENUS_SUCCESS";
export const GET_USER_MENUS_FAILURE = "GET_USER_MENUS_FAILURE";
